import { getFarcasterAccount } from "@/lib/api/discover"
import { Suspense } from "react"
import { SiFarcaster } from "react-icons/si"

export function FarcasterIconWithSuspense({
  walletAddress,
}: {
  walletAddress: string
}) {
  return (
    <Suspense>
      <Farcaster walletAddress={walletAddress} />
    </Suspense>
  )
}

async function Farcaster({ walletAddress }: { walletAddress: string }) {
  const fcUser = await getFarcasterAccount(walletAddress)

  if (!fcUser) return null

  return (
    <a
      href={`https://warpcast.com/${fcUser.username}`}
      target="_blank"
      rel="noreferrer"
    >
      <SiFarcaster className="h-5 w-5 full-muted-foreground hover:fill-slate-700 transition-all" />
    </a>
  )
}
